import { autoinject, bindingMode, observable } from 'aurelia-framework';
import { ComponentBase, IForm } from 'app/shared/lib/essette-site';
import { bindable } from 'aurelia-typed-observable-plugin';
import { AdmissionCareDayService } from 'app/um/services/admission-care-day-service';
import { Toaster } from 'app/shared/lib/toaster';
import { apiCall } from 'app/shared/lib/essette-api';
import * as UM from 'app/um/models/essette-api';

@autoinject()
export class SaveDischargeLocation extends ComponentBase implements IForm {

    ////****************** Fields and Properties ************************************////
    @bindable.object({ defaultBindingMode: bindingMode.twoWay, changeHandler: 'reset' })
    protected dischargeLocation: UM.DischargeLocation = {};

    @observable()
    protected description: string = '';
    @observable()
    protected code: string = '';

    ////****************** Element References ***************************************////

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly service: AdmissionCareDayService,
        private readonly toaster: Toaster,
        ...rest: any[]) {
        super(...rest);
    }

    ////****************** Events ***************************************************////

    ////****************** Functions ************************************************////
    public reset(): void {
        this.description = this.dischargeLocation.description ?? '';
        this.code = this.dischargeLocation.code ?? '';
    }

    public async submit(): Promise<boolean> {
        return this.saveDischargeLocation();
    }

    public hasChanges(): boolean {
        throw new Error('Method not implemented.');
    }

    protected buildDischargeLocation(): UM.DischargeLocation {
        const dischargeLocation: UM.DischargeLocation = {
            id: this.dischargeLocation.id || null,
            description: this.description,
            code: this.code
        };

        return dischargeLocation;
    }

    ////****************** Service Calls ********************************************////
    @apiCall
    private async saveDischargeLocation(): Promise<boolean> {
        if(!this.dischargeLocation) return false;

        let isSuccessful = false;
        try {
            this.state.beginSave();

            const response = await this.service.saveDischargeLocation(this.buildDischargeLocation());
            isSuccessful = response.isSuccessful;
            return isSuccessful;
        } catch(error) {
            throw error;
        } finally {
            this.toaster.standard.saved('um:auth.discharge.location.$', isSuccessful);
            this.state.endSave();
        }
    }
}
